var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchieverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#F2B200"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4625_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20312 4C7.20312 4.85669 7.20312 7.25519 7.20312 8.28319C7.20312 11.7954 10.3072 13.166 12.0003 13.166C13.6934 13.166 16.7975 11.7954 16.7975 8.28319C16.7975 7.25519 16.7975 4.85669 16.7975 4H7.20312ZM12.0093 5.57972L9.87922 6.50997V9.58728L9.87769 10.1976C9.86125 10.1941 8.40038 9.88159 8.40038 7.74787C8.40038 6.86756 8.40038 5.57288 8.40038 5.57288H10.2874L12.0093 5.57972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8587 16.5222L13.1152 15.4836L12.7436 13.9531L12.0001 14.0624L11.2567 13.9531L10.8849 15.4836L10.4172 16.1371L10.1416 16.5147H10.147L10.1416 16.5222H13.8587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4668 17.5075V17.5H8.53369V19.9874V19.9925V20H15.4668V17.5126V17.5075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.989 7.02068C19.988 6.98105 19.9869 6.94768 19.9869 6.92149V5.40918H17.6779V6.61968H18.7764V6.92149C18.7764 6.95671 18.7775 7.0014 18.7791 7.05455C18.7912 7.4913 18.8198 8.51415 18.1058 9.2484C17.9458 9.41296 17.7551 9.55424 17.5365 9.6738C17.4151 10.2249 17.2205 10.7227 16.9707 11.168C17.8007 10.9678 18.4715 10.6087 18.9737 10.0923C20.0442 8.99149 20.0041 7.55974 19.989 7.02068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89473 9.2484C5.18073 8.51415 5.20929 7.4913 5.22157 7.05455C5.22304 7.0014 5.22414 6.95671 5.22414 6.92149V6.61968H6.31295H6.31514H6.32263V5.40918H4.01363V6.92149C4.01363 6.94768 4.01263 6.98105 4.01151 7.02068C3.99645 7.55974 3.95651 8.99149 5.02695 10.0923C5.52907 10.6087 6.19979 10.9678 7.02982 11.168C6.77995 10.7227 6.58545 10.2248 6.4641 9.67377C6.24538 9.55418 6.05476 9.41296 5.89473 9.2484Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4625_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchieverIcon);
export default __webpack_public_path__ + "static/media/AchieverIcon.b5f212dbfb3e366dc142b5e2065d7af2.svg";
export { ForwardRef as ReactComponent };